import { render, staticRenderFns } from "./UserPresenceList.vue?vue&type=template&id=5bba8048&scoped=true"
import script from "./UserPresenceList.js?vue&type=script&lang=js&external"
export * from "./UserPresenceList.js?vue&type=script&lang=js&external"
import style0 from "./UserPresenceList.scss?vue&type=style&index=0&id=5bba8048&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bba8048",
  null
  
)

export default component.exports